export default __webpack_public_path__ + "903caa0026a107e09386a54ae0be080c.ttf";